import { datePickerConfig, dateFormat } from './datepickerConfig';
import { DateRangePicker } from 'tiny-date-picker/dist/date-range-picker';
import './datepicker.scss';

export default class RangeDatePicker {
  constructor(options) {
    this.root = options.root;
    this.txtStart = options.txtStart;
    this.txtEnd = options.txtEnd;
    this.hiddenDateInput = options.hiddenDateInput;
    this.datepickerContainer = options.datepickerContainer;
    this.lang = document.documentElement.lang.substring(0, 2);
    this.datePickerObj = null;
  }

  init = () => {
    // Inject DateRangePicker into our container
    this.datePickerObj = DateRangePicker(this.datepickerContainer, {
      startOpts: {
        lang: datePickerConfig,
        format(date) {
          return dateFormat(date);
        },
        parse(str) {
          // parse slectedDate back to datepicker
          if (str) {
            const dateArray = str.split('.').reverse();
            const dateString = dateArray.join('-');

            return new Date(dateString);
          } else {
            const date = new Date(str);
            return isNaN(date) ? new Date() : date;
          }
        },
      },
      endOpts: {
        lang: datePickerConfig,
        format(date) {
          return dateFormat(date);
        },
        parse(str) {
          // parse slectedDate back to datepicker
          if (str) {
            const dateArray = str.split('.').reverse();
            const dateString = dateArray.join('-');

            return new Date(dateString);
          } else {
            const date = new Date(str);
            return isNaN(date) ? new Date() : date;
          }
        },
      },
    });

    this.datePickerObj.on('statechange', (_, rp) => {
      // Update the inputs when the state changes
      const range = rp.state;

      let startDate = range.start ? this.dateFormatter(range.start) : null;
      let endDate = range.end ? this.dateFormatter(range.end) : null;

      // close datepicker if start and enddate are set
      if (startDate && endDate) {
        this.datepickerContainer.classList.remove('ex-inputs-picker-visible');
      }

      // if startDate was set, but not endDate, use rangeMax as endDate
      // else if startDate was NOT set, but endDate was, use rangeMin as startdDate
      if (startDate && !endDate) {
        endDate = this.dateFormatter(range.start);
      } else if (!startDate && endDate) {
        startDate = this.dateFormatter(range.end);
      }

      this.txtStart.value = startDate
        ? `${startDate.day}.${startDate.month}.${startDate.year}`
        : '';
      this.txtEnd.value = endDate
        ? `${endDate.day}.${endDate.month}.${endDate.year}`
        : '';

      if (this.hiddenDateInput) {
        const dateString = `${startDate.year}${startDate.month}${startDate.day}0000-${endDate.year}${endDate.month}${endDate.day}2359`;
        this.hiddenDateInput.value = dateString;
      }
    });

    this.bindEvents();
  };

  bindEvents = () => {
    // When the inputs gain focus, show the date range picker
    this.txtStart.addEventListener('focus', this.showPicker);
    this.txtEnd.addEventListener('focus', this.showPicker);

    // If focus leaves the root element, it is not in the date
    // picker or the inputs, so we should hide the date picker
    // we do this in a setTimeout because redraws cause temporary
    // loss of focus.
    let previousTimeout;
    this.root.addEventListener('focusout', () => {
      clearTimeout(previousTimeout);
      previousTimeout = setTimeout(() => {
        if (!this.root.contains(document.activeElement)) {
          this.datepickerContainer.classList.remove('ex-inputs-picker-visible');
        }
      }, 10);
    });
  };

  showPicker = () => {
    this.datepickerContainer.classList.add('ex-inputs-picker-visible');
  };

  /**
   * This functions expect an Javascript Date Object.
   * Returns an object of formatted day, month, year and the Date Object itself.
   * @param {dateObj} Date - New Date() Object
   */
  dateFormatter = dateObj => {
    const year = dateObj.getFullYear();
    const dateMonth = dateObj.getMonth() + 1;
    const month = dateMonth < 10 ? `0${dateMonth}` : dateMonth;
    const dateDay = dateObj.getDate();
    const day = dateDay < 10 ? `0${dateDay}` : dateDay;

    return {
      dateObj,
      day,
      month,
      year,
    };
  };
}
